(function($) {

    'use strict';
    
    var scrolled = false;

	var init = function() {

        if($('section').hasClass('listingContent')){

            var offset = $('#listing-param').data('offset');
            var post_per_page = $('#listing-param').data('postperpage');
            var current_cats = $('#listing-param').data('currentcats');
            var listing_post_type = $('#listing-param').data('listingposttype');
            var exclude_item = $('#listing-param').data('exclude');
            var lang = $('main').data('lang') ? $('main').data('lang') : null;
            console.log(lang);

            $(window).scroll(function(){

                var scrollPosition = $(window).height() + $(window).scrollTop();
                var scrollListBottom = $(".listingContent__list").offset().top + $(".listingContent__list").outerHeight();

                if( !scrolled && scrollPosition >= scrollListBottom){

                    scrolled = true;

                    offset = listing_ajax(offset, current_cats, listing_post_type, exclude_item, post_per_page, lang);

                }

            });

        }
	};

	var listing_ajax = function(offset, current_cats, listing_post_type, exclude_item, post_per_page, lang){

        jQuery.post(
            ajaxurl,
            {
                'action': 'infinite_scroll_listing',
                'offset': offset,
                'post_per_page': post_per_page,
                'current_cats': current_cats,
                'listing_post_type': listing_post_type,
                'exclude_item': exclude_item,
                'lang': lang,
            },
            function(response){

                if(response != 'false'){

                    $('.listingContent__list').append(response);

                    scrolled = false;

                }

            }
        );

        return offset += post_per_page;

    };

	$(document).ready(function() {
		init();
	});

})(jQuery);
